import React, { memo } from "react";
import {
  SocialCard,
  SocialCardGroup,
  socialLinks
} from "./social-card/SocialCard";
import { Props } from "../dashboard/DashboardSocialCards";

export const CommunitySocialCards: React.FC<Props> = memo(() => {
  const content = socialLinks.map(
    ({ platform, label, href, icon, tagline }, i) => (
      <SocialCard
        key={i}
        platform={platform}
        href={href}
        label={label}
        icon={icon}
        tagline={tagline}
      />
    )
  );
  return <SocialCardGroup>{content}</SocialCardGroup>;
});
CommunitySocialCards.displayName = "CommunitySocialCards";
